export const sx = {
    wrapper: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        flexWrap: 'wrap',
        padding: '5px 0',
        gap: '3px',
        width: '100%'

    }
}